module.exports = __webpack_public_path__ + "img/toast-close.0ff70821.svg";